import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import {
  //ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_GENERATED,
  ElectronicDocumentDisablement,
} from "../../models/electronic-document-disablement";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import {
  DISABLEMENTS_DESTROY,
  DISABLEMENTS_UPDATE,
} from "../../auth/permissions";

interface DisablementCrudActionsProps {
  disablement: ElectronicDocumentDisablement;
  //onCancellationClick: (_: ElectronicDocumentDisablement) => void;
  onUpdateClick: (_: ElectronicDocumentDisablement) => void;
  onDeleteClick: (_: ElectronicDocumentDisablement) => void;
}

const DisablementCrudActions: React.FC<DisablementCrudActionsProps> = ({
  disablement,
  //onCancellationClick,
  onUpdateClick,
  onDeleteClick,
}) => {
  /*const cancelButton = (
    <PermissionRequiredComponent permissionName={DISABLEMENTS_UPDATE}>
      <CTooltip content="Anular">
        <CButton
          className="text-white"
          color="secondary"
          onClick={() => {
            onCancellationClick(disablement);
          }}
        >
          <i className="fa fa-ban"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );
  */
  const editButton = (
    <PermissionRequiredComponent permissionName={DISABLEMENTS_UPDATE}>
      <CTooltip content="Editar">
        <CButton
          className="text-white"
          color="warning"
          onClick={() => {
            onUpdateClick(disablement);
          }}
        >
          <i className="fa fa-pencil"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  const deleteButton = (
    <PermissionRequiredComponent permissionName={DISABLEMENTS_DESTROY}>
      <CTooltip content="Eliminar">
        <CButton
          className="text-white"
          color="danger"
          onClick={() => {
            onDeleteClick(disablement);
          }}
        >
          <i className="fa fa-trash"></i>
        </CButton>
      </CTooltip>
    </PermissionRequiredComponent>
  );

  /*const shouldShowCancelButton =
    disablement.status === ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_GENERATED;
  */
  const shouldShowEditAndDeleteButton = true;

  return (
    <td className="text-center">
      <CButtonGroup>
        {/*shouldShowCancelButton ? cancelButton : <></>*/}
        {shouldShowEditAndDeleteButton ? (
          <>
            {editButton}
            {deleteButton}
          </>
        ) : (
          <></>
        )}
      </CButtonGroup>
    </td>
  );
};

export default DisablementCrudActions;
